<div class="tabbassiCard card col" [ngClass]="{'showPMU': showPMUTab}" *ngIf="!loading && !sideCol">
  <div class="card-header row p-0">
    <div class="text-center p-2" *ngIf="showPMUTab" (click)="selectedTabIndex = 0" [ngClass]="{'selected-tab': selectedTabIndex === 0,
                     'col-6': showPMUTab}">{{ "HOME.NEXT_PMU_BETTING" | translate }}</div>
    <div class="text-center p-2" (click)="selectedTabIndex = 1" [ngClass]="{'selected-tab': selectedTabIndex === 1 && showPMUTab,
                     'col-6': showPMUTab}">{{ "HOME.NEXT_BETTING" | translate }}</div>
  </div>
  <div class="card-body text-break table-small-text p-0">
    <table class="table table-striped mb-0">
      <tbody>
        <tr class="row-hover" *ngFor="let item of opportunities" (click)="goToRaceDetails(item)">
          <td class="w-3 px-1" [ngStyle]="{'min-width': '37px'}">
            <img src="../../../../assets/media/icons/{{getRaceType(item)}}.webp" [alt]="getRaceType(item)"
              [pTooltip]="getRaceType(item)" tooltipPosition="right" />
          </td>
          <td>{{ item.localDatetime | date : "HH:mm"}}</td>
          <td>
            <img [src]="getFlagSlug(item.Country)" alt="{{ item.Country + ' ' + 'flag' }}" class="flag"
              onerror="this.src=''" />
          </td>
          <td [ngClass]="{'font-weight-bold': selectedTabIndex === 0}">{{ item.Track }}</td>
          <td class="d-none d-md-inline-block" *ngIf="selectedTabIndex === 0">{{ item.Title }}</td>
          <td> {{ "RACES.RACE_C" | translate | raceCourse : item.RaceIndex:sideCol }}</td>
          <td class="text-right font-weight-500" *ngIf="item.dateDiffMin > 59">{{("HOME.IN" | translate) + '
            '+item.dateDiffHour + ' Hr..'}}
          </td>
          <!-- <td class="text-right font-weight-500" *ngIf="item.dateDiffMin < 2 ">
            {{ ("HOME.IN" | translate) + ' 2 min.'}}
            {{ "HOME.STARTING" | translate }}
          </td> -->
          <td class="text-right font-weight-500" *ngIf="item.dateDiffMin > 0 && item.dateDiffMin < 60 ">
            {{ ("HOME.IN" | translate) + ' '+item.dateDiffMin + ' min.'}}
          </td>
          <td class="remaining-time" *ngIf="item.dateDiffMin == 0 ">
            {{ "RACES.STARTING" | translate}} </td>
        </tr>
        <tr *ngIf="page==='home'">
          <td [attr.colspan]="selectedTabIndex === 0 ? 7:6" class="text-right c-p font-weight-500" [routerLink]="goUrl">
            <span>{{ "HOME.MORE" | translate }}</span> &nbsp;
            <i class="fa fa-arrow-right"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<!-- Side column race list start -->
<p-accordion *ngIf="!loading && sideCol">
  <p-accordionTab [(selected)]="!collapsed" header="{{ 'MENU.NEXT_RACES' | translate }}">
    <div class="tabbassiCard card col" [ngClass]="{'showPMU': showPMUTab}">
      <div class="card-header row p-0">
        <div class="text-center p-2" *ngIf="showPMUTab" (click)="updateNextRaces(0)"
          [ngClass]="{'selected-tab': selectedTabIndex === 0,'col-6': showPMUTab}">
          {{ "MENU.PMU_RACES_SHORT" | translate }}
        </div>
        <div class="text-center p-2" (click)="updateNextRaces(1)"
          [ngClass]="{'selected-tab': selectedTabIndex === 1 && showPMUTab,'col-6': showPMUTab}">
          {{ "MENU.ALL_RACES_SHORT" | translate }}
        </div>
      </div>
      <div class="card-body text-break table-small-text p-0">
        <table class="table table-striped mb-0">
          <tbody>
            <tr class="row-hover" *ngFor="let item of opportunities" (click)="goToRaceDetails(item)">
              <td class="w-3 px-0 race-type-icon">
                <img src="../../../../assets/media/icons/{{getRaceType(item)}}.webp" [alt]="getRaceType(item)"
                  [pTooltip]="getRaceType(item)" tooltipPosition="right" />
              </td>
              <td>{{ item.Track }}</td>
              <td class="pr-0" [style.white-space]="'nowrap'">
                {{ "RACES.RACE_C" | translate | raceCourse : item.RaceIndex: sideCol }}
              </td>
              <td class="remaining-time" *ngIf="item.dateDiffMin > 59">{{item.dateDiffHour + ' Hr..'}} </td>
              <!-- <td class="remaining-time" *ngIf="item.dateDiffMin < 2 ">
                {{ "HOME.STARTING_SHORT" | translate }}
                {{ '2 min.'}}
              </td> -->
              <td class="remaining-time" *ngIf="item.dateDiffMin > 0 && item.dateDiffMin < 60 ">
                {{ item.dateDiffMin + ' min.'}} </td>
              <td class="remaining-time" *ngIf="item.dateDiffMin == 0 ">
                {{ "RACES.STARTING" | translate}} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </p-accordionTab>
</p-accordion>
<!-- Side column race list end -->

<div class="d-xl-none" *ngIf="!router.url.includes('next-races/all')">
  <div class="space-10"></div>
  <app-top-wining [collapsed]="false"></app-top-wining>
</div>

<app-loading-screen *ngIf="loading"></app-loading-screen>